var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpiTheme2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5232 3.93007L33.6555 19.7583C33.66 19.767 33.6581 19.7776 33.6508 19.7842L16.3981 35.4602C16.3935 35.4643 16.3897 35.4675 16.3866 35.4699C16.3823 35.4683 16.3774 35.4658 16.3721 35.4626C16.3668 35.4593 16.3624 35.4558 16.3591 35.4528C16.3599 35.4489 16.361 35.4441 16.3627 35.4382L25.4831 3.93394C25.4847 3.92847 25.4862 3.92435 25.4874 3.92136C25.491 3.92016 25.496 3.91899 25.5018 3.91842C25.5077 3.91786 25.5128 3.91806 25.5166 3.91854C25.5183 3.92124 25.5206 3.92501 25.5232 3.93007Z",
    fill: "white",
    stroke: "#5A5CE7",
    strokeWidth: 2.88
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9802 3.93007L24.1125 19.7583C24.117 19.767 24.1151 19.7776 24.1079 19.7842L6.85509 35.4602C6.85056 35.4643 6.84671 35.4675 6.84359 35.4699C6.83937 35.4683 6.83439 35.4658 6.8291 35.4626C6.82381 35.4593 6.81946 35.4558 6.8161 35.4528C6.8169 35.4489 6.81806 35.4441 6.81976 35.4382L15.9402 3.93394C15.9418 3.92847 15.9432 3.92435 15.9444 3.92136C15.9481 3.92016 15.953 3.91899 15.9589 3.91842C15.9647 3.91786 15.9698 3.91806 15.9736 3.91854C15.9754 3.92124 15.9776 3.92501 15.9802 3.93007Z",
    fill: "#9EA0FF",
    stroke: "#5A5CE7",
    strokeWidth: 2.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpiTheme2);
export default __webpack_public_path__ + "static/media/UPITheme2.aa05c95f9cacbcca684a83edf6666e9a.svg";
export { ForwardRef as ReactComponent };